import { render, staticRenderFns } from "./StaticServices.vue?vue&type=template&id=035c9f1c&"
import script from "./StaticServices.vue?vue&type=script&lang=js&"
export * from "./StaticServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports